export enum AnnouncementAdminCommentStatusType {
    Approved = 'success',
    Pending = 'warning',
    Rejected = 'danger'
}
